import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import {
    cancelOrder,
    fetchOrder,
    resetCart,
    setAdyenRedirection,
    waitForOrderStatusChange
} from 'shared/store/ecommerce/order'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata, pageMetadata } from 'shared/store/metadata'
import type { RootState } from 'shared/store/reducers'
import type { DeviceCheck, MetaShortDTO } from 'shared/types'
import { CartConfirmationComponent } from './CartConfirmationComponent'
import { featureCodes } from 'shared/utils'

const mapStateToProps = (state: RootState) => {
    const { cacOrders, deliveryOrders } = state.ecommerceOrderState
    const isActiveZendesk = state.featuresState.available.includes(
        featureCodes.ACTIVATION_ZENDESK_REDIRECTION
    )
    return {
        orders: { ...cacOrders, ...deliveryOrders },
        isActiveZendesk
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    navigate: (to: string) => d(push(to)),
    resetCart: () => d(resetCart()),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    cancelOrder: (id: string, token: string, deviceCheckPayload: DeviceCheck) =>
        d(cancelOrder(id, token, deviceCheckPayload)),
    pageMetadata: (payload: MetaShortDTO) => d(pageMetadata(payload)),
    fetchOrder: (id: string, token: string) => d(fetchOrder(id, token)),
    resetAdyenRedirection: () => d(setAdyenRedirection(undefined)),
    waitForOrderStatusChange: (token: string) =>
        d(waitForOrderStatusChange(token))
})

export const CartConfirmation = connect(
    mapStateToProps,
    mapDispatchToProps
)(CartConfirmationComponent)
